import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select'; // Import react-select for multi-selector
import 'react-toastify/dist/ReactToastify.css';

export default function AddStudentDetails() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, name } = location.state || {};
  const [selectionType, setSelectionType] = useState('one'); // State to hold "One" or "Many" selection
  const focusInputRef = useRef(null); // Ref for the username input
  const [isLoading, setIsLoading] = useState(false);
  const [subjectOptions, setSubjectOptions] = useState([]); // State to hold subject options
  const [formData, setFormData] = useState({
    name: '',
    rollNumber: '',
    subjectCode: [], // Array to hold selected subject objects
  });
  const currentPath = location?.pathname || '';
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();
  }, [navigate]);
  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  useEffect(() => {
    // Fetch subjects from the updated API
    const token = localStorage.getItem('token');
    axios
      .get(`${apiUrl}/api/subject/list/${id}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        // Map the API response to react-select options
        const subjects = res.data.subjectExam.map((subject) => ({
          value: subject.subjectCode, // Store the subjectCode as the value
          label: `${subject.subjectname} (${subject.subjectCode})`, // Display subject name and code
          name: subject.subjectname, // Store subject name
        }));
        setSubjectOptions(subjects); // Set the options for react-select
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        console.error('Failed to fetch subjects:', err);
      });
  }, [apiUrl]);

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const token = localStorage.getItem('token');

    const payload = {
      name: formData.name,
      rollNumber: formData.rollNumber,
      examId: id,
      subjectCode: formData.subjectCode, // Sending array of subject name-code pairs
    };

    axios
      .post(`${apiUrl}/api/students`, payload, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        setIsLoading(false);
        toast.success('Student added successfully');
        focus();

        setFormData({
          name: '',
          rollNumber: '',
          subjectCode: [], // Reset subject selections
        });
        if (selectionType === 'one' && currentPath === '/AddStudentDetails') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/AddStudentDetails') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        setIsLoading(false);
        toast.error(err.response.data.message || 'An error occurred');
      });
  };

  const handleChange = (selectedOptions) => {
    // Convert selected options into an array of objects with subject names and codes
    const subjects = selectedOptions.map((option) => ({
      [option.name]: option.value, // Creates { "SubjectName": subjectCode } objects
    }));

    setFormData((prevState) => ({
      ...prevState,
      subjectCode: subjects, // Set the array of subject name-code pairs
    }));
  };

  return (
    <>
      <AdminLayout ac6="active">
        <main id="main" className="main">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  {' '}
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer" onClick={() => navigate(-1)}>
                    Exams for Student
                  </span>
                </li>
                <li className="breadcrumb-item active">
                  Add New Student for ({name})
                </li>
              </ol>
            </nav>
          </div>
          <div className="row text-center">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body mt-5 mx-3">
                  <form onSubmit={handleSubmit}>
                    <div className="container">
                      <div className="row row-cols-2">
                        <div className="col-6">
                          <div className="form-floating mb-2">
                            <input
                              ref={focusInputRef}
                              className="form-control"
                              type="text"
                              name="rollNumber"
                              value={formData.rollNumber}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  rollNumber: e.target.value,
                                })
                              }
                              placeholder="Roll Number"
                              required
                            />
                            <label className="form-label">
                              Roll Number <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  name: e.target.value,
                                })
                              }
                              placeholder="Name"
                              required
                            />
                            <label className="form-label">
                              Name <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="form-floating mb-2">
                            <Select
                              closeMenuOnSelect={false}
                              isMulti
                              name="subjectIds"
                              options={subjectOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              onChange={handleChange}
                              value={subjectOptions.filter((option) =>
                                formData.subjectCode.some(
                                  (selectedSubject) =>
                                    selectedSubject[option.name] ===
                                    option.value
                                )
                              )} // Add the value prop to clear the select
                              placeholder="Select Subjects"
                            />
                          </div>
                        </div>
                        <div className="col-12  ">
                          <div className="d-flex flex-row-reverse">
                            <div className="p-2">
                              <button
                                type="submit"
                                className="btn btn-primary px-4 "
                                disabled={isLoading}
                              >
                                {isLoading ? 'Saving...' : 'Save'}
                              </button>
                            </div>
                            <div className="p-2 px-0">
                              <button
                                type="button"
                                className="btn btn-primary "
                                onClick={() => navigate(-1)}
                              >
                                <i className="bi bi-arrow-bar-left"></i> Back
                              </button>
                            </div>
                            <div className="p-2 mt-2">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input recode-switch"
                                  type="checkbox"
                                  id="selectionSwitch"
                                  checked={selectionType === 'many'} // Toggle the state
                                  onChange={() =>
                                    setSelectionType(
                                      selectionType === 'many' ? 'one' : 'many'
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="selectionSwitch"
                                >
                                  {selectionType === 'many'
                                    ? 'Many Student Add'
                                    : 'One Student Add'}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </AdminLayout>
    </>
  );
}
